import styled from 'styled-components';
import {defaultTheme} from "../../styles/themes/default";

export const Container = styled.div`
  position: relative;
  display: inline-block;
`

interface FilterButtonProps{
    active: boolean
}

export const FilterButton = styled.button<FilterButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: ${({active}) => active ? defaultTheme.accentLightest : defaultTheme.grayBackground};
  color: ${({active}) => active ? defaultTheme.accent : defaultTheme.grayDark };
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  border: unset;
  svg{
    margin-right: 10px;
    path{
      fill: ${({active}) => active ? defaultTheme.accent : defaultTheme.grayLight }
    }
  }
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    all: unset;
    p{
      display: none;
      svg{
        margin-right: unset;
      }
    }
    :hover {
      cursor: pointer;
    }
  }
`
export const FiltersContainer = styled.ul`
  position: absolute;
  height: fit-content;
  width: 205px;
  top: 100%;
  right: 0;
  z-index: 1;
  padding: 8px 0;
  margin-top: 20px;
  background: ${({theme}) => theme.white};
  border-radius: 6px;
  border: 1px solid ${({theme}) => theme.grayDivider};
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.06);
`

export const FilterItem = styled.div`
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  color: ${({theme}) => theme.accent};
  display: flex;
  align-items: center;
  justify-content: left;
`
